import { render, staticRenderFns } from "./UploadDocumentDialog.vue?vue&type=template&id=2d52ecce&scoped=true"
import script from "./UploadDocumentDialog.vue?vue&type=script&lang=js"
export * from "./UploadDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentDialog.vue?vue&type=style&index=0&id=2d52ecce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52ecce",
  null
  
)

export default component.exports